(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BZ-main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cms-monetate-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Also guard against a script being evaluated again during dynamic rendering.
  if (window.__bzMonetateRecommendations) {
    window.__bzMonetateRecommendations.initAll(document);
    return;
  }
  const sectionSelector = '[data-monetate-recs="true"]';
  const instances = new WeakMap();
  const isCurrent = (instance) =>
    !instance.disposed && instance.section.isConnected && instances.get(instance.section) === instance;

  const formatMoney = (cents) => {
    if (typeof cents !== 'number' || Number.isNaN(cents)) return '';
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  };

  const parseHandleFromLink = (link) => {
    if (!link) return '';
    try {
      const url = new URL(link, window.location.origin);
      const parts = url.pathname.split('/').filter(Boolean);
      const productIndex = parts.indexOf('products');
      if (productIndex >= 0 && parts[productIndex + 1]) {
        return parts[productIndex + 1];
      }
      return parts[parts.length - 1] || '';
    } catch {
      return '';
    }
  };

  // Successful and in-flight product lookups are shared, but slot metadata never is.
  const productRequests = new Map();

  /** Normalize to identifier for Shopify Data Products API (ecomm_product_id or pim.item_number). */
  const toIdentifier = (productId) => { 
    if (productId == null) return '';
    const raw = String(productId).trim();
    if (!raw) return '';
    if (raw.startsWith('gid://')) return raw.replace(/^gid:\/\/shopify\/Product\//i, '').trim() || raw;
    return raw;
  };

  /**
   * Fetch products by identifiers via POST /apps/retailmediasolutions/shopifyData/products.
   * Returns a Map: identifier -> product (so we can look up by rec.id).
   */
  const fetchProductsByIds = (identifiers) => {
    const ids = [...new Set(identifiers.map(toIdentifier).filter(Boolean))].sort();
    if (ids.length === 0) return Promise.resolve(new Map());
    const cacheKey = JSON.stringify([
      window.location.origin,
      window.Shopify?.routes?.root || '/',
      window.Shopify?.currency?.active || 'USD',
      window.Shopify?.locale || document.documentElement.lang,
      ids,
    ]);
    if (productRequests.has(cacheKey)) return productRequests.get(cacheKey);
    const request = (async () => {
      // This timeout belongs to the shared request, not to either section's lifecycle.
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 6000);
      try {
        const response = await fetch('/apps/retailmediasolutions/shopifyData/products', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ identifiers: ids }),
          signal: controller.signal,
        });
        if (!response.ok) throw new Error(`Monetate product lookup failed: ${response.status}`);
        const result = await response.json();
        if (!Array.isArray(result?.products)) throw new Error('Invalid Monetate product response');
        const map = new Map();
        for (const product of result.products) {
          if (!product) continue;
          for (const value of [product.id, product.ecomm_product_id, product.pim_item_number]) {
            const id = toIdentifier(value);
            if (id) map.set(id, product);
          }
        }
        return map;
      } finally {
        // Keep the timeout active while the response body is being read as well.
        clearTimeout(timeoutId);
      }
    })().catch((error) => {
      productRequests.delete(cacheKey);
      throw error;
    });
    productRequests.set(cacheKey, request);
    return request;
  };

  const getProductImageUrl = (product) => {
    if (!product) return '';
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image?.url) return product.featured_image.url;
    if (typeof product.image === 'string') return product.image;
    if (product.image?.src) return product.image.src;
    if (product.image?.url) return product.image.url;
    if (product.featured_media?.preview_image?.src) {
      return product.featured_media.preview_image.src;
    }
    if (product.featured_media?.preview_image?.url) {
      return product.featured_media.preview_image.url;
    }
    if (Array.isArray(product.images) && product.images.length) {
      const first = product.images[0];
      if (typeof first === 'string') return first;
      if (first?.src) return first.src;
      if (first?.url) return first.url;
    }
    return '';
  };

  const normalizeImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('//')) return `https:${url}`;
    return url;
  };

  const CARD_IMAGE_WIDTHS = [240, 352, 480, 640, 832, 1200];
  const INDEXED_ASSET_SUFFIX = /^(?:E0[1-4]|0[1-4])$/;

  const isTextbookProduct = (product) => {
    const rawTags = product?.tags;
    const tags = Array.isArray(rawTags) ? rawTags : String(rawTags || '').split(',');
    const normalized = tags.map((tag) => String(tag).trim().toLowerCase());
    if (normalized.includes('adoptedtitle') || normalized.includes('adoptedsupply')) return true;
    return String(product?.template_suffix || product?.templateSuffix || '').toLowerCase() === 'textbook';
  };

  const shopifyFilePublicId = (url, monetateImageConfig) => {
    let parsed;
    try {
      parsed = new URL(url);
    } catch {
      return null;
    }

    const parts = parsed.pathname.split('/').filter(Boolean);
    if (!parts.length) return null;

    let path = parts.slice(parts[0] === 'cdn' ? 1 : 0).join('/');
    if (path.includes('s/files/')) {
      path = path.split('/files/').pop() || path;
    }
    path = path.split('?')[0];
    if (monetateImageConfig.cdnPath) {
      path = path.replace(/^shop\/files\//, monetateImageConfig.cdnPath);
    }

    const filename = path.split('/').pop() || '';
    const extensionIndex = filename.lastIndexOf('.');
    let cleanFilename = extensionIndex > 0 ? filename.slice(0, extensionIndex) : filename;
    const uuidSuffix = cleanFilename.includes('_') ? cleanFilename.split('_').pop() : '';
    if (uuidSuffix.length === 36 && uuidSuffix.includes('-')) {
      cleanFilename = cleanFilename.slice(0, -(uuidSuffix.length + 1));
    }

    const publicPath = cleanFilename === filename
      ? path
      : path.slice(0, path.length - filename.length) + cleanFilename;

    return {
      publicPath,
      cleanFilename,
      version: parsed.searchParams.get('v') || '',
    };
  };

  const cloudinaryAssetName = (cleanFilename) => {
    const defaultAsset = '/d_gmdef.jpg';
    const suffix = cleanFilename.split('_').pop();
    const assetBase = INDEXED_ASSET_SUFFIX.test(suffix)
      ? cleanFilename.slice(0, -(suffix.length + 1))
      : cleanFilename;
    if (!assetBase) return { publicId: cleanFilename, defaultAsset };

    // No default asset on the `_01` request: when it is missing, the card's onerror retries the Shopify
    // file name and only then falls back to the d_gmdef.jpg placeholder.
    return { publicId: `${assetBase}_01`, defaultAsset: '' };
  };

  const cloudinaryImageUrl = (rawUrl, width, product, monetateImageConfig) => {
    const url = normalizeImageUrl(rawUrl);
    if (!url) return '';

    const textbook = isTextbookProduct(product);
    const cdnSource = textbook ? monetateImageConfig.textbookSource : monetateImageConfig.gmSource;
    if (cdnSource !== 'cloudinary' || textbook) return url;

    const parsed = shopifyFilePublicId(url, monetateImageConfig);
    if (!parsed?.cleanFilename || !monetateImageConfig.prefix) return url;

    const asset = cloudinaryAssetName(parsed.cleanFilename);
    const publicPath = parsed.publicPath.endsWith(parsed.cleanFilename)
      ? parsed.publicPath.slice(0, -parsed.cleanFilename.length) + asset.publicId
      : asset.publicId;
    const version = parsed.version ? `/v${parsed.version}` : '';
    const transform = monetateImageConfig.transform || '';

    return `${monetateImageConfig.prefix}${transform}/c_limit,w_${width}${asset.defaultAsset}${version}/${publicPath}`;
  };

  const recommendationImageTag = (rawUrl, alt, product, cardConfig) => {
    const fallback = normalizeImageUrl(rawUrl);
    if (!fallback) return '';

    const src = cloudinaryImageUrl(fallback, 832, product, cardConfig.images);
    const converted = src !== fallback;
    const srcset = converted
      ? CARD_IMAGE_WIDTHS.map((width) => `${cloudinaryImageUrl(fallback, width, product, cardConfig.images)} ${width}w`).join(', ')
      : '';
    const srcsetAttr = srcset ? ` srcset="${escapeHtml(srcset)}"` : '';
    const onerrorAttr = converted ? ` ${cardConfig.imageOnerror}` : '';

    return `<img src="${escapeHtml(src)}"${srcsetAttr} alt="${alt}" width="832" height="832" loading="lazy" sizes="auto, (min-width: 750px) 20.0vw, 100vw" class="bz-product-card__image"${onerrorAttr}>`;
  };

  // brand now comes from the rec payload first, so it is third-party text going into innerHTML.
  // Mirrors sections/sponsored-products.liquid, which escapes the same field.
  const escapeHtml = (value) =>
    String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');

  const isProductAvailable = (product) => {
    if (!product) return false;
    const status = String(product.status || '').toUpperCase();
    if (status && status !== 'ACTIVE') return false;
    const variants = Array.isArray(product.variants) ? product.variants : [];
    if (variants.length > 0) {
      const hasInventorySignals = variants.some(
        (variant) =>
          typeof variant.available === 'boolean' ||
          variant.inventory_quantity != null
      );
      if (hasInventorySignals) {
        return variants.some((variant) => {
          if (variant.available === true) return true;
          const inventory = variant.inventory_quantity;
          if (inventory == null) return false;
          return Number(inventory) > 0;
        });
      }
    }
    if (typeof product.available === 'boolean') return product.available;
    return true;
  };

  const buildCard = (data, quickViewLabel, hideQuickView, cardConfig) => {
    const wrapper = document.createElement('article');
    wrapper.classList.add('bz-product-card');
    const title = escapeHtml(data.title || '');
    const handle = data.handle || '';
    const productHandle = handle ? `/products/${handle}` : data.url || '#';
    const imageUrl = data.image || '';
    const price = data.price ? formatMoney(data.price) : '';
    const compare_at_price = data.compare_at_price ? formatMoney(data.compare_at_price) : '';
    const brand = data.brand || '';
    const shopName = cardConfig.shopName;
    const showBrand = brand.trim() !== '' && brand.trim().toLowerCase() !== String(shopName || '').trim().toLowerCase();
      
    const quickViewBlock = hideQuickView ? '' : `
          <div class="hover-add-to-cart-block">
            <quick-add-component class="monetate-recs__quick-add" data-product-title="${title}" data-product-handle="${handle}">
              <button type="button" class="button hover-add-to-cart-button" on:click="quick-add-component/handleClick" data-product-handle="${handle}">
                <span class="add-to-cart-text__content">${escapeHtml(quickViewLabel || 'Quick view')}</span>
              </button>
            </quick-add-component>
          </div>`;

    const brandBlock = `${showBrand ? `<div class="spacing-style text-block custom brand-block" style="--padding-block-start: 0px; --padding-block-end:0px; --padding-inline-start:0px; --padding-inline-end:0px;">
            <p>${escapeHtml(brand)}</p>
          </div>` : ''}`;
        

    const compareAtPriceBlock = `${data.compare_at_price && data.compare_at_price > data.price ? `<span class="compare-at-price">${compare_at_price}</span>` : ''}`;
    const saleBadge = data.compare_at_price > data.price ? cardConfig.saleBadge : '';

    wrapper.innerHTML = `
      ${saleBadge}
      <div class="bz-product-card__media-wrap" data-product-id="${data.id || ''}">
        <a class="bz-product-card__media-link" href="${productHandle}" aria-label="${title}">
          ${imageUrl ? recommendationImageTag(imageUrl, title, data.product, cardConfig) : `<svg class="bz-product-card__placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"></path></svg>`}
        </a>
      </div>
      <div class="bz-product-card__body">
        ${brandBlock}
        <h3 class="bz-product-card__title">
          <a href="${productHandle}">${title}</a>
        </h3>
        <div class="bz-product-card__price-row">
          <product-price data-product-id="${data.id || ''}">
            <div class="${data.compare_at_price > data.price ? "compare_price" : ''}">
              <span class="bz-product-card__price">
                <span class="price">${price}</span>
                ${compareAtPriceBlock}
              </span>
            </div>
          </product-price>
        </div>
        ${quickViewBlock}
      </div>`;

    return wrapper;
  };

  const getCentsFromProduct = (product) => {
    const price = product?.price ?? product?.variants?.[0]?.price;
    if (price == null) return null;
    const cents = Number(price);
    return Number.isNaN(cents) ? null : cents;
  };

  const getCompareAtCentsFromProduct = (product) => {
    const compare_at_price = product?.compare_at_price ?? product?.variants?.[0]?.compare_at_price;
    if (compare_at_price == null) return null;
    const compare_at_cents = Number(compare_at_price);
    return Number.isNaN(compare_at_cents) ? null : compare_at_cents;
  };

  /**
   * Reads recommendation data for this section instance. If `pinnedSlot` is set (via the section's
   * "Certona slot name" setting), reads that slot directly - lets a second carousel on the same page
   * (e.g. a PRODUCT page's product2_rr rail) use a slot other than the page's default first one.
   * Otherwise falls back to the first populated slot for this page type, as before.
   */
  const getCertonaRecs = (pinnedSlot) => {
    if (pinnedSlot && typeof window.getCertonaSlotData === 'function') {
      const slot = window.getCertonaSlotData(pinnedSlot);
      const items = slot && Array.isArray(slot.items) ? slot.items : [];
      const slotLabel = (slot && slot.slotLabel && String(slot.slotLabel).trim()) ? String(slot.slotLabel).trim() : '';
      return { items, slotLabel };
    }
    if (typeof window.getCertonaRecommendationsForPage !== 'function') {
      return { items: [], slotLabel: '' };
    }
    const slots = window.getCertonaRecommendationsForPage();
    if (!slots || slots.length === 0) return { items: [], slotLabel: '' };
    const first = slots[0];
    const items = first && first.items && Array.isArray(first.items) ? first.items : [];
    const slotLabel = (first && first.slotLabel && String(first.slotLabel).trim()) ? String(first.slotLabel).trim() : '';
    return { items, slotLabel };
  };

  const certonaItemToRec = (item) => {
    const productId = item.itemGroupId || item.id;
    const priceDollars = item.salePrice != null ? item.salePrice : item.price;
    const priceCents = priceDollars != null ? Math.round(Number(priceDollars) * 100) : null;
    return {
      id: productId,
      title: item.title,
      link: item.link,
      imageLink: item.imageLink,
      price: priceCents,
      brand: item.brand,
      productType: item.productType,
      itemGroupId: item.itemGroupId,
      recToken: item.recToken || '',
    };
  };

  // Same precedence as monetate.liquid: ecomm_product_id, then pim.item_number, then Shopify product id.
  const getMonetateProductId = (product) => { 
    const ecommId = String(product?.ecomm_product_id ?? '').trim();
    if (/^\d+$/.test(ecommId)) return ecommId;
    const pimId = String(product?.pim_item_number ?? '').trim();
    if (/^\d+$/.test(pimId)) return pimId;
    const shopifyId = toIdentifier(product?.id);
    return /^\d+$/.test(shopifyId) ? shopifyId : '';
  };

  const reportRecImpressions = (tokens) => {
    if (!tokens.length) return;
    window.monetateQ = window.monetateQ || [];
    window.monetateQ.push(['reportRecImpressions', tokens]);
  };

  const bindRecClickTracking = (track, instance) => {
    const onClick = (event) => {
      if (!isCurrent(instance)) return;
      if (!event.target.closest('a, button')) return;
      const recToken = event.target.closest('[data-rec-token]')?.dataset.recToken;
      if (!recToken) return;
      window.monetateQ = window.monetateQ || [];
      window.monetateQ.push(['reportRecClicks', recToken]);
    };
    track.addEventListener('click', onClick);
    instance.cleanupClicks = () => track.removeEventListener('click', onClick);
  };

  const hydrateSection = async (instance, recsData) => {
    const { section } = instance;
    const track = section.querySelector('[data-monetate-recs-track]');
    const slideshow =
      section.querySelector('slideshow-component[ref="monetateRecsCarousel"]') ||
      section.querySelector('slideshow-component');
    if (!track || !slideshow) {
      setSectionState(section, 'hidden');
      return;
    }

    const minItems = Number(section.getAttribute('data-min-items') || 0);
    const maxItems = Number(section.getAttribute('data-max-items') || 0);
    const normalizedMinItems = Number.isFinite(minItems) && minItems > 0 ? minItems : 1;
    const normalizedMaxItems = Number.isFinite(maxItems) && maxItems > 0
      ? Math.max(maxItems, normalizedMinItems)
      : 0;
    const quickViewLabel = section.getAttribute('data-quick-view-label') || 'Quick view';
    const hideQuickView = section.getAttribute('data-monetate-recs-hide-quick-view') === 'true';
    const cardConfig = {
      images: JSON.parse(section.dataset.monetateImageConfig || '{}'),
      imageOnerror: section.dataset.monetateImageOnerror || '',
      shopName: section.dataset.monetateShopName || '',
      saleBadge: section.querySelector('[data-monetate-sale-badge]')?.innerHTML || '',
    };

    const certonaItems = recsData.items || [];
    if (!certonaItems.length) {
      setSectionState(section, 'hidden');
      return;
    }

    track.innerHTML = '';
    const seenIds = new Set();
    const recs = certonaItems
      .map(certonaItemToRec)
      .filter((rec) => {
        const id = toIdentifier(rec.id);
        if (!id || seenIds.has(id)) return false;
        seenIds.add(id);
        return true;
      });
    const items = recs.slice(0, normalizedMaxItems || recs.length);
    if (items.length === 0) {
      setSectionState(section, 'hidden');
      return;
    }

    const identifiers = items.map((rec) => toIdentifier(rec.id)).filter(Boolean);
    const productsMap = await fetchProductsByIds(identifiers);
    if (!isCurrent(instance)) return;

    let slidesAdded = 0;
    const renderedRecTokens = [];
    items.forEach((rec, index) => {
      const product = productsMap.get(toIdentifier(rec.id));
      if (!product) return;
      if (!isProductAvailable(product)) return;
      const handle = product?.handle || parseHandleFromLink(rec.link);

      let prodImageUrl;
      if(getProductImageUrl(product)){
        prodImageUrl = normalizeImageUrl(getProductImageUrl(product));
      }

      const data = {
        id: product?.id || rec.id,
        handle,
        title: product?.title || rec.title,
        url: handle ? `/products/${handle}` : (rec.link || '#'),
        image: prodImageUrl || 'https://media.bkstr.com/image/upload/c_pad,w_400,h_400,b_white/gmdef',
        price: product ? getCentsFromProduct(product) : rec.price,
        compare_at_price: product ? getCompareAtCentsFromProduct(product) : rec.compare_at_price,
        brand: rec.brand || product?.vendor,
        productType: product?.product_type || rec.productType,
        options: product?.options || [],
        allVariants: product?.variants || [],
        recToken: rec.recToken || '',
        product,
      };

      const slide = document.createElement('div');
      slide.className = 'bz-collection-slider__slide';
      // slide.setAttribute('ref', 'slides[]');
      slide.setAttribute('role', 'listitem');
      slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      slide.setAttribute('data-bz-slider-card', true);
      slide.dataset.faIndex = String(slidesAdded);
      slide.dataset.faComponent = 'product rail';
      const recToken = data.recToken;
      if (recToken) {
        slide.dataset.recToken = recToken;
        renderedRecTokens.push(recToken);
      }
      const card = buildCard(data, quickViewLabel, hideQuickView, cardConfig);
      slide.appendChild(card);
      track.appendChild(slide);
      slidesAdded += 1;
    });

    if (slidesAdded < normalizedMinItems) {
      setSectionState(section, 'hidden');
      return;
    }

    const headingEl = section.querySelector('[data-monetate-recs-heading]');
    // Heading set in the section settings (CMS) wins; otherwise use the slotLabel Monetate returned for the slot.
    const themeHeading = (section.getAttribute('data-theme-heading') || '').trim();
    const monetateLabel = (recsData.slotLabel && String(recsData.slotLabel).trim()) ? String(recsData.slotLabel).trim() : '';
    const slotLabel = themeHeading || monetateLabel;
    if (slotLabel) {
      track.querySelectorAll('[data-bz-slider-card]').forEach((slide) => {
        slide.dataset.faName = slotLabel;
      });
    }
    if (headingEl) {
      if (slotLabel) {
        headingEl.textContent = slotLabel;
        headingEl.style.display = '';
      } else {
        headingEl.textContent = '';
        headingEl.style.display = 'none';
      }
    }

    // Reveal before measuring: the slider needs a laid out (not display: none) section to size itself.
    setSectionState(section, 'visible');

    if (typeof slideshow.refresh === 'function') {
      instance.refreshFrame = requestAnimationFrame(() => {
        instance.refreshFrame = null;
        if (isCurrent(instance)) slideshow.refresh();
      });
    }

    window.BZCollectionSlider?.refresh(section);
    bindRecClickTracking(track, instance);
    reportRecImpressions(renderedRecTokens);
  };

  const setSectionState = (section, state) => {
    const loader = section.querySelector('[data-monetate-recs-loader]');
    const content = section.querySelector('[data-monetate-recs-content]');
    // Expose the state ('loading' | 'hidden' | 'visible') and announce it, so other code can wait for the outcome.
    if (section.dataset.monetateState !== state) {
      section.dataset.monetateState = state;
      document.dispatchEvent(new CustomEvent('bz:monetate-recs-state', { detail: { section, state } }));
    }
    if (state === 'loading') {
      // Stay hidden while waiting: the section only appears once it has enough products to show.
      section.style.display = 'none';
      if (loader) {
        loader.style.display = 'none';
        loader.setAttribute('aria-hidden', 'true');
      }
      if (content) content.style.display = 'none';
    } else if (state === 'hidden') {
      section.style.display = 'none';
      if (loader) { loader.style.display = 'none'; loader.setAttribute('aria-hidden', 'true'); }
      if (content) content.style.display = 'none';
    } else if (state === 'visible') {
      section.style.display = '';
      if (loader) { loader.style.display = 'none'; loader.setAttribute('aria-hidden', 'true'); }
      if (content) { content.style.display = ''; }
    }
  };

  /**
   * Hydrates a recs section as soon as its Certona slot has data, instead of polling on a fixed
   * schedule. Monetate's tag has to load, then round-trip to the personalization API, before a
   * certonaCallback (and our 'monetate:certona-recs-updated' event) arrives - a fixed ~2.5s budget
   * could miss that on a slow connection and hide the carousel even though data was on its way.
   * Reacts to the event, with an immediate check in case data already landed, and a generous timeout
   * as a last resort so the loading state doesn't run forever if Monetate never responds.
   */
  const hydrateFromCertona = (instance) => {
    const { section } = instance;
    const pinnedSlot = (section.dataset.certonaSlot || '').trim();
    // If this page type has no Certona slot mapped at all (and this instance isn't pinned to a specific
    // slot), nothing will ever arrive for it - hide immediately instead of spinning for up to 8s only to
    // hide anyway. Once a slot *is* mapped, we still have to wait, since we can't know in advance whether
    // Certona will actually return data for it.
    const hasSlotToWaitFor =
      Boolean(pinnedSlot) || (Array.isArray(window.__certonaSlotsForPage) && window.__certonaSlotsForPage.length > 0);
    if (!hasSlotToWaitFor) {
      setSectionState(section, 'hidden');
      return;
    }

    let settled = false;
    let giveUpTimer = null;
    let answeredTimer = null;
    let answeredPayloads = 0;

    const cleanup = () => {
      document.removeEventListener('monetate:certona-recs-updated', tryHydrate);
      if (giveUpTimer) clearTimeout(giveUpTimer);
      if (answeredTimer) clearInterval(answeredTimer);
    };
    instance.cleanupWait = cleanup;

    const tryHydrate = () => {
      if (settled || !isCurrent(instance)) return;
      const recsData = getCertonaRecs(pinnedSlot);
      if ((recsData.items || []).length > 0) {
        settled = true;
        cleanup();
        hydrateSection(instance, recsData).catch(() => {
          if (isCurrent(instance)) setSectionState(section, 'hidden');
        });
      }
    };

    const giveUp = () => {
      if (settled) return;
      settled = true;
      cleanup();
      if (isCurrent(instance)) setSectionState(section, 'hidden');
    };

    setSectionState(section, 'loading');
    document.addEventListener('monetate:certona-recs-updated', tryHydrate);
    giveUpTimer = setTimeout(giveUp, 8000);
    tryHydrate(); // in case data already landed before this listener was attached
    if (settled) return;

    // Monetate answers a page with one response (sst + the certonaCallback of every slot it serves). Once it has
    // answered and this slot is still empty a moment later, nothing more is coming for it: resolve now instead of
    // waiting out the full 8s, so whatever depends on the outcome (the PDP Shopify fallback) is not delayed.
    let lastCount = 0;
    let lastChangeAt = Date.now();
    answeredTimer = setInterval(() => {
      if (settled) return;
      const count = Array.isArray(window.__monetatePageEventResponse) ? window.__monetatePageEventResponse.length : 0;
      if (count !== lastCount) {
        lastCount = count;
        lastChangeAt = Date.now();
        answeredPayloads = count;
      }
      if (answeredPayloads > 0 && Date.now() - lastChangeAt > 2500) {
        tryHydrate();
        if (!settled) giveUp();
      }
    }, 250);
  };

  const forEachSection = (scope, callback) => {
    if (scope.matches?.(sectionSelector)) callback(scope);
    scope.querySelectorAll(sectionSelector).forEach(callback);
  };

  const initAll = (scope) => {
    forEachSection(scope, (section) => {
      if (!section.isConnected || instances.has(section)) return;
      // Claim this DOM instance before any callbacks or asynchronous work can begin.
      const instance = { section, disposed: false };
      instances.set(section, instance);
      hydrateFromCertona(instance);
    });
  };

  const disposeAll = (scope) => {
    forEachSection(scope, (section) => {
      const instance = instances.get(section);
      if (!instance) return;
      instance.disposed = true;
      instance.cleanupWait?.();
      instance.cleanupClicks?.();
      if (instance.refreshFrame != null) cancelAnimationFrame(instance.refreshFrame);
      window.BZCollectionSlider?.destroy(section);
      instances.delete(section);
    });
  };

  window.__bzMonetateRecommendations = { initAll };
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => disposeAll(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  } catch(e) { console.error(e); }
})();
})();
